import React from 'react';
import NegativeCashflowView from './Types/NegativeCashflowView';

const FinancialPlanWarningView = ({
  clientId,
  warningMessage,
  warningType,
  hasWarningMessage,
  goToCashflow,
  hidden,
}) => {
  if (!hasWarningMessage || (hidden && warningType === 'RESET')) {
    return null;
  }
  switch (warningType) {
    case 'NEGATIVE_CASHFLOW':
      return (
        <NegativeCashflowView
          warningMessage={warningMessage}
          goToCashflow={goToCashflow(clientId)}
        />
      );
    default:
      return null;
  }
};

export default FinancialPlanWarningView;
